
export async function tracking(trackingLinkId, language) {

    const response = await fetch('/api/data/tracking/'+trackingLinkId+'/'+language);
    return await response.json();
}